import {
    getFirestore,
    doc,
    getDoc,
    collection,
    getDocs,
    query,
    where,
    getCountFromServer,
  } from "firebase/firestore";
import { Result } from "../../models/result";
import { User } from "../../models/user/user";


export const getStaffBySchool = async (schoolId) => {
    try{
        const db = getFirestore();
        const staffCollectionRef = collection(db, "schools", schoolId, "users");
        const q = query(staffCollectionRef, where("type", "not-in", [1, 7, 6]));
        const querySnapshot = await getDocs(q);
        const staff = [];
        querySnapshot.forEach((doc) => {
            staff.push(doc.data());
        });
        return new Result({
            value: staff,
        });
    }catch(ex){
        console.error(ex);
        return new Result({
            error: ex.message,
        });
    }

}

export const getTotalNumberOfActiveStaff = async (schoolId) => {
    try{
        const db = getFirestore();
        const staffCollectionRef = collection(db, "schools", schoolId, "users");
        const q = query(staffCollectionRef, where("type", "not-in", [1, 7, 6]));
        const count = await getCountFromServer(q);
        return new Result({
            value: count.data().count,
        });
    }catch(ex){
        console.error(ex);
        return new Result({
            message: ex.message,
        });
    }
}